import { useState } from 'react'
import { Modal, Radio } from 'antd'

import { RejectReasonModal } from './RejectReasonModal'

type ChangeStatusModalProps = {
  open: boolean
  onClose: () => void
  requestId: string
}

export const ChangeStatusModal = ({
  open,
  onClose,
  requestId,
}: ChangeStatusModalProps) => {
  const [value, setValue] = useState<string>('rejected')
  const [isRejectReasonOpen, setIsRejectReasonOpen] = useState(false)

  const handleNext = () => {
    setIsRejectReasonOpen(true)
  }

  const handleSuccess = () => {
    setIsRejectReasonOpen(false)
    onClose()
  }
  return (
    <>
      <Modal
        title="Change the status"
        open={open && !isRejectReasonOpen}
        onCancel={onClose}
        okText="Next"
        cancelText="Cancel"
        onOk={handleNext}
      >
        <Radio.Group
          value={value}
          onChange={(e) => setValue(e.target.value)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            marginTop: 16,
          }}
        >
          <Radio value="rejected">Rejected</Radio>
          <Radio value="banned">Rejected + ban</Radio>
        </Radio.Group>
      </Modal>

      <RejectReasonModal
        open={isRejectReasonOpen}
        onCancel={() => setIsRejectReasonOpen(false)}
        status={value}
        requestId={requestId}
        onSuccess={handleSuccess}
      />
    </>
  )
}
